// ML001-F0239 (UI half of the ML001-F0238 segregation-of-duties rule, Core ML001-D007 section 7.8.5).
// No principal performs a money action on their OWN customer account, whatever their role (super_admin
// included), and a principal without ledger_manage performs none at all. Core and the Ledger enforce this;
// the UI is the courtesy: a money control that is not allowed is NOT RENDERED (not merely disabled).
//
// One predicate (this file, pure) and one hook (useMoneyActionGate.js), used by every Ledger money surface (account page credit form, Advice / Approval
// queues and their move forms, the Credit notes tag, the transaction history drawer). Fail closed: an
// unknown permission, viewer or target is "no".

export const MONEY_ACTION_PERMISSION = 'ledger_manage';

const present = (value) => value !== null && value !== undefined && String(value) !== '';

// Maker-checker (owner refinement 2026-10-10): the viewer's own account. Unknown viewer or target counts as own (fail closed),
// so a control that needs "someone else" never renders on a guess.
export const isOwnAccount = (viewerId, targetUserId) => !present(viewerId) || !present(targetUserId) || String(viewerId) === String(targetUserId);

// permissions: the viewer's my-permissions projection for the organisation ({ledger_manage: true, ...}).
export function canPerformMoneyActions({ permissions, viewerId, targetUserId }) {
  if (permissions?.[MONEY_ACTION_PERMISSION] !== true) return false;
  if (!present(viewerId) || !present(targetUserId)) return false;
  return String(viewerId) !== String(targetUserId);
}
